import React, { useState, useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ContentContainer, MainContent, CenteredCard, StyledTableContainer, StyledTableHead, StyledTableColumn, StyledTableCell, StyledChartCard, RefreshIcon, HeaderTitle, CustomTextField, CustomTooltip } from '../Styles/MapOverview';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import IconButton from '@mui/material/IconButton';
import { Link } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import refreshIcon from '../Images/refresh-icon.svg';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import { format } from 'date-fns';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../Parts/Sidebar';
import Header from '../Parts/Header';
import Footer from '../Parts/Footer';
import { useLogoTitle } from '../classes/LogoTitleContext';
import axios from 'axios';
import getAuthHeaders from '../Auth/Authentication';
import { API_ENDPOINTS } from '../Auth/apiConfig';
import pdfIcon from '../Images/pdf-icon.svg';
import excelIcon from '../Images/excel-icon.svg';
import goBackIcon from '../Images/goBackIcon.png';
import dayjs from 'dayjs';
import jsPDF from 'jspdf';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

const MapOverview = ({ onLogout, loggedInUser }) => {
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
    const navigate = useNavigate();
    const { logoUrl, projectTitle } = useLogoTitle();
    const [loading, setLoading] = useState(true);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [tableData, setTableData] = useState([]);
    const [selectedDateFrom, setSelectedDateFrom] = useState(null);
    const [selectedDateTo, setSelectedDateTo] = useState(null);
    const [chartData, setChartData] = useState([]);
    const [minValue, setMinValue] = useState(null);
    const [maxValue, setMaxValue] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const { chamberNumber } = useParams();
    const [potOptions, setPotOptions] = useState([]);
    const [detailedDataDefaultReport, setdetailedDataDefaultReport] = useState([]);
    const [detailedData2DefaultReport, setdetailedData2DefaultReport] = useState([]);
    const [detailedData3, setDetailedData3] = useState([]);

    const today = new Date(); // today's date
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 30);

    const [currentPageOne, setCurrentPageOne] = useState(1);
    const [currentPageTwo, setCurrentPageTwo] = useState(1);
    const rowsPerPageOne = 15;
    const rowsPerPageTwo = 15;
    // Calculate the index range for the current page
    const startRowIndexOne = (currentPageOne - 1) * rowsPerPageOne;
    const startRowIndexTwo = (currentPageTwo - 1) * rowsPerPageTwo;
    const endRowIndexOne = startRowIndexOne + rowsPerPageOne;
    const endRowIndexTwo = startRowIndexTwo + rowsPerPageTwo;
    // Paginate the data
    const paginatedDataOne = detailedData3.slice(startRowIndexOne, endRowIndexOne);
    const paginatedDataTwo = detailedData2DefaultReport.slice(startRowIndexTwo, endRowIndexTwo);
    // Handle page change event
    const handlePageChangeOne = (event, newPage) => {
        setCurrentPageOne(newPage);
    };

    // Handle page change event
    const handlePageChangeTwo = (event, newPage) => {
        setCurrentPageTwo(newPage);
    };

    const formatDate = (dateString) => {
        // Parse the date string in the format DD-MM-YYYY HH:MM:SS
        const [datePart] = dateString.split(' '); // Extract the date part
        const [day, month, year] = datePart.split('-'); // Split into day, month, year
        return `${day}/${month}/${year}`; // Format as DD/MM/YYYY
    };

    const formatTime = (dateString) => {
        if (!dateString) {
            return ''; // Return an empty string if the dateString is falsy
        }

        // Split the dateString into date and time parts
        const parts = dateString.split(' ');

        // Check if the time part exists
        if (parts.length < 2) {
            return ''; // Return an empty string if there's no time part
        }

        const timePart = parts[1]; // Get the time part

        // If the time part exists, return it formatted as HH:MM:SS
        return timePart.split(':').slice(0, 3).join(':');
    };

    const TableOne = async () => {
        setLoading(true);
        handleClear();

        // Get current date and date 1 day ago
        const currentDate = moment().format('YYYY-MM-DD');
        const thirtyDaysAgo = moment().subtract(30, 'days').format('YYYY-MM-DD');

        try {
            const authHeaders = getAuthHeaders();
            const response = await axios.post(`${API_ENDPOINTS.potAnalyticsData}`, {
                selectedDPs: chamberNumber,
                selectedVPs: chamberNumber,
                selectedDateFrom: thirtyDaysAgo,
                selectedDateTo: currentDate,
                projectID: loggedInUser.Projectid,
                TimeDiff: loggedInUser.TimeDiff,
            }, {
                headers: authHeaders
            });

            // Set the fetched data to the state
            setdetailedDataDefaultReport(response.data);

            setLoading(false);
        } catch (error) {
            console.error('Error fetching Pot Analytics data:', error);
            setLoading(false);
        }
    };

    const TableTwo = async () => {
        try {
            // Get current date and date 1 day ago
            const currentDate = moment().format('YYYY-MM-DD');
            const thirtyDaysAgo = moment().subtract(30, 'days').format('YYYY-MM-DD');

            const authHeaders = getAuthHeaders();
            const response = await axios.post(
                `${API_ENDPOINTS.perdaypotcycle}`,
                {
                    selectedDPs: chamberNumber,
                    selectedVPs: chamberNumber,
                    selectedDateFrom: thirtyDaysAgo,
                    selectedDateTo: currentDate,
                    clientId: loggedInUser.clientId,
                    projectID: loggedInUser.Projectid,
                    TimeDiff: loggedInUser.TimeDiff,
                },
                {
                    headers: authHeaders
                }
            );

            // Set the fetched data to the state
            setdetailedData2DefaultReport(response.data);

            // Return the data
            return response.data;

        } catch (error) {
            console.error('Error fetching Per Day Pot Cycle data:', error);
            setLoading(false);
            // Return undefined or handle the error accordingly
            return undefined;
        }
    };

    const TableThree = async (potName) => {
        try {
            // Get current date and date 1 day ago
            const currentDate = moment().format('YYYY-MM-DD');
            const thirtyDaysAgo = moment().subtract(30, 'days').format('YYYY-MM-DD');

            const authHeaders = getAuthHeaders();
            const response = await axios.post(`${API_ENDPOINTS.potclickdata}`, {
                row: { HEADER: chamberNumber },
                selectedDateFrom: thirtyDaysAgo,
                selectedDateTo: currentDate,
                projectID: loggedInUser.Projectid,
                TimeDiff: loggedInUser.TimeDiff,
            },
                {
                    headers: authHeaders
                });

            //console.log('Response Data of POTCLICK:', response.data);
            // Update state with the fetched data
            setDetailedData3(response.data);

        } catch (error) {
            console.error('Error fetching Pot click data:', error);
            //toast.error('Error fetching data');
        }
    };

    useEffect(() => {
        // Fetch data for TableOne and TableTwo
        const fetchData = async () => {
            try {
                setLoading(true);
                await TableOne(); // Fetch data for TableOne
                await TableTwo(); // Fetch data for TableTwo
                await TableThree();
            } catch (error) {
                console.error('Error fetching data', error);
            } finally {
                setLoading(false); // Stop loading after both fetches are done
            }
        };
        fetchData();
    }, []);


    const handleSearch = () => {
        if (selectedDateFrom && selectedDateTo) {
            const filtered = tableData.filter((item) => {
                const itemDate = dayjs(item.Date);
                return itemDate.isAfter(selectedDateFrom) && itemDate.isBefore(selectedDateTo);
            });
            setFilteredData(filtered);
            setChartData(filtered.map((item) => ({
                Date: item.Date,
                RowNumber: parseInt(item.RowNumber),
                DailyVacuumAverage: parseFloat(item.DailyVacuumAverage),
            })));
        }
    };

    const handleClear = () => {
        setSelectedDateFrom(null);
        setSelectedDateTo(null);
    };

    const handleDownloadPDF = () => {
        const doc = new jsPDF({
            orientation: 'landscape',
        });

        // Function to generate table content
        const generateTableContent = (tableData, columns, startY) => {
            const rows = tableData.map(row => {
                return columns.map(column => {
                    switch (column.key) {
                        case 'HEADER':
                            return row.HEADER || '0';
                        case 'Total_Duration':
                            return row.Total_Duration || '0Sec';
                        case 'Avg_Duration':
                            return row.Avg_Duration || '0Sec';
                        case 'Max_Duration':
                            return row.Max_Duration || '0Sec';
                        case 'Min_Duration':
                            return row.Min_Duration || '0Sec';
                        case 'Total_Cycles':
                            return row.Total_Cycles || '0'
                        case 'Total_ValveAlarm':
                            return row.Total_ValveAlarm;
                        case 'Total_floatAlarm':
                            return row.Total_floatAlarm || '0';
                        case 'Date':
                            return row.Date || '';
                        case 'POTS':
                            return row.POTS || '0';
                        case 'CYCLEDURATION':
                            return row.CYCLEDURATION || '0Sec';
                        case 'TotalCYCLES':
                            return row.TotalCYCLES || '0';
                        case 'POT':
                            return row.POT || '0';
                        case 'STARTDATE':
                            return formatDate(row.cycleStartTime) || '0';
                        case 'STARTTIME':
                            return formatTime(row.cycleStartTime) || '0';
                        case 'STOPDATE':
                            return formatDate(row.cycleStopTime) || '0';
                        case 'STOPTIME':
                            return formatTime(row.cycleStopTime) || '0';
                        case 'DURATION':
                            return row.DURATION || '0Sec';
                        default:
                            return '';
                    }
                });
            });

            // Add a smaller space after each table
            doc.autoTable({
                head: [columns.map(column => column.label)],
                body: rows,
                startY: startY,
                headStyles: {
                    fillColor: [200, 200, 200],
                    textColor: [0, 0, 0],
                    fontSize: 12,
                    fontStyle: 'bold',
                },
                theme: 'striped', // Optional: Adds alternating row colors
            });

            return doc.autoTable.previous.finalY + 10; // Adjust this value as needed
        };

        // Add Title
        const title = `Analytics overview for Pot: ${chamberNumber}`;
        const titleWidth = doc.getStringUnitWidth(title) * doc.internal.getFontSize() / doc.internal.scaleFactor;
        const pageWidth = doc.internal.pageSize.width;
        const xTitle = (pageWidth - titleWidth) / 2;
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(18);
        doc.text(title, xTitle, 20);

        // Add Project Name below the title
        const projectName = `Project Name: ${loggedInUser && loggedInUser.project_description}`;
        const projectNameWidth = doc.getStringUnitWidth(projectName) * doc.internal.getFontSize() / doc.internal.scaleFactor;
        const xProjectName = (pageWidth - projectNameWidth) / 2;
        doc.text(projectName, xProjectName, 30);

        // Get current date and date 7 days ago
        const currentDate = moment().format('DD-MM-YYYY');
        const sevenDaysAgo = moment().subtract(1, 'days').format('DD-MM-YYYY');
        const fromDateText = `Date between: ${selectedDateFrom ? format(selectedDateFrom, 'dd-MM-yyyy') : sevenDaysAgo} / ${selectedDateTo ? format(selectedDateTo, 'dd-MM-yyyy') : currentDate}`;
        const fromDateWidth = doc.getStringUnitWidth(fromDateText) * doc.internal.getFontSize() / doc.internal.scaleFactor;
        const xFromDate = (pageWidth - fromDateWidth) / 2;
        doc.text(fromDateText, xFromDate, 40);

        // Starting y-position for the first table
        let startY = 50;

        // Generate PDF content based on each table
        if (detailedDataDefaultReport.length > 0) {
            const columns1 = [
                { key: 'HEADER', label: 'Pot name' },
                { key: 'Total_Cycles', label: 'Total valve runs' },
                { key: 'Total_ValveAlarm', label: 'Total valve alarms' },
                { key: 'Total_floatAlarm', label: 'Total float alarms' },
                { key: 'Total_Duration', label: 'Total run time' },
                { key: 'Avg_Duration', label: 'Average run time' },
                { key: 'Max_Duration', label: 'Max run time' },
                { key: 'Min_Duration', label: 'Min run time' }
            ];
            startY = generateTableContent(detailedDataDefaultReport, columns1, startY);
        }

        if (detailedData2DefaultReport.length > 0) {
            const columns2 = [
                { key: 'POTS', label: 'Pot' },
                { key: 'Date', label: 'Date' },
                { key: 'CYCLEDURATION', label: 'Total run time/day' },
                { key: 'TotalCYCLES', label: 'Total runs/day' }
            ];
            startY = generateTableContent(detailedData2DefaultReport, columns2, startY);
        }

        if (detailedData3.length > 0) {
            const columns3 = [
                { key: 'POT', label: 'POT' },
                { key: 'STARTDATE', label: 'Start date' },
                { key: 'STARTTIME', label: 'Start time' },
                { key: 'STOPDATE', label: 'Stop date' },
                { key: 'STOPTIME', label: 'Stop time' },
                { key: 'DURATION', label: 'Run time' }
            ];
            generateTableContent(detailedData3, columns3, startY);
        }

        // Save the PDF
        doc.save(`pot_overview_${chamberNumber}.pdf`);
    };


    const handleDownloadExcel = () => {
        const XLSX = require('xlsx');
        const wb = XLSX.utils.book_new();
        const wsData = [];
        const currentDate = moment().format('DD-MM-YYYY');
        const sevenDaysAgo = moment().subtract(1, 'days').format('DD-MM-YYYY');
        // Header lines
        const headerLines = [
            [`Analytics overview for Pot: ${chamberNumber}`],
            [`Project Name: ${loggedInUser && loggedInUser.project_description}`],
            [`Date between: ${selectedDateFrom ? format(selectedDateFrom, 'dd-MM-yyyy') : sevenDaysAgo} / ${selectedDateTo ? format(selectedDateTo, 'dd-MM-yyyy') : currentDate}`]
        ];
        wsData.push(...headerLines);

        // Function to generate Excel content for a specific data set
        const generateExcelContent = (data, columns) => {
            const header = columns.map(column => column.label);
            const rows = data.map(row => columns.map(column => {
                switch (column.key) {
                    case 'HEADER':
                        return row.HEADER || '0';
                    case 'Total_Duration':
                        return row.Total_Duration || '0Sec';
                    case 'Avg_Duration':
                        return row.Avg_Duration || '0Sec';
                    case 'Max_Duration':
                        return row.Max_Duration || '0Sec';
                    case 'Min_Duration':
                        return row.Min_Duration || '0Sec';
                    case 'Total_Cycles':
                        return row.Total_Cycles || '0'
                    case 'Total_ValveAlarm':
                        return row.Total_ValveAlarm;
                    case 'Total_floatAlarm':
                        return row.Total_floatAlarm || '0';
                    case 'Date':
                        return row.Date || '';
                    case 'POTS':
                        return row.POTS || '0';
                    case 'CYCLEDURATION':
                        return row.CYCLEDURATION || '0Sec';
                    case 'TotalCYCLES':
                        return row.TotalCYCLES || '0';
                    case 'POT':
                        return row.POT || '0';
                    case 'STARTDATE':
                        return formatDate(row.cycleStartTime) || '0';
                    case 'STARTTIME':
                        return formatTime(row.cycleStartTime) || '0';
                    case 'STOPDATE':
                        return formatDate(row.cycleStopTime) || '0';
                    case 'STOPTIME':
                        return formatTime(row.cycleStopTime) || '0';
                    case 'DURATION':
                        return row.DURATION || '0Sec';
                    default:
                        return '';
                }
            }));

            // Add empty row for spacing
            rows.push(Array(header.length).fill(''));
            return [header, ...rows];
        };

        if (detailedDataDefaultReport.length > 0) {
            const columns1 = [
                { key: 'HEADER', label: 'Pot name' },
                { key: 'Total_Cycles', label: 'Total valve runs' },
                { key: 'Total_ValveAlarm', label: 'Total valve alarms' },
                { key: 'Total_floatAlarm', label: 'Total float alarms' },
                { key: 'Total_Duration', label: 'Total run time' },
                { key: 'Avg_Duration', label: 'Average run time' },
                { key: 'Max_Duration', label: 'Max run time' },
                { key: 'Min_Duration', label: 'Min run time' },
            ];
            wsData.push(...generateExcelContent(detailedDataDefaultReport, columns1));
        }

        if (detailedData2DefaultReport.length > 0) {
            const columns2 = [
                { key: 'POTS', label: 'Pot name' },
                { key: 'Date', label: 'Date' },
                { key: 'CYCLEDURATION', label: 'Total run time/day' },
                { key: 'TotalCYCLES', label: 'Total runs/day' }
            ];
            wsData.push(...generateExcelContent(detailedData2DefaultReport, columns2));
        }

        if (detailedData3.length > 0) {
            const columns3 = [
                { key: 'POT', label: 'Pot' },
                { key: 'STARTDATE', label: 'Start date' },
                { key: 'STARTTIME', label: 'Start time' },
                { key: 'STOPDATE', label: 'Stop date' },
                { key: 'STOPTIME', label: 'Stop time' },
                { key: 'DURATION', label: 'Run time' }
            ];
            wsData.push(...generateExcelContent(detailedData3, columns3));
        }

        // Create a single worksheet from all data
        const ws = XLSX.utils.aoa_to_sheet(wsData);

        // Set column widths and style for centered alignment
        const range = XLSX.utils.decode_range(ws['!ref']);
        for (let C = range.s.c; C <= range.e.c; ++C) {
            const colWidth = wsData.reduce((acc, row) => Math.max(acc, `${row[C]}`.length), 0) + 3;
            ws['!cols'] = ws['!cols'] || [];
            ws['!cols'][C] = { wch: colWidth, s: { alignment: { horizontal: 'center' } } };
        }

        // Append the worksheet to the workbook
        XLSX.utils.book_append_sheet(wb, ws, `${chamberNumber}`);

        // Save the Excel file
        XLSX.writeFile(wb, `pot_overview_${chamberNumber}.xlsx`);
    };

    const handleDateFrom = (date) => {
        setSelectedDateFrom(date);
    };

    const handleDateTo = (date) => {
        setSelectedDateTo(date);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(event.target.value);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div style={{ backgroundColor: '#EBEFF3' }}>
                <Sidebar loggedInUser={loggedInUser} />
                <Header logoUrl={logoUrl} loggedInUser={loggedInUser} onLogout={onLogout} />
                <ContentContainer>
                    <MainContent>
                        <Grid container spacing={2} justifyContent="center">
                            <Grid item xs={12} lg={20}>
                                <CardContent>
                                    <Box mb={2} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography variant="h5" component="h1" align="center" sx={{
                                            flex: 0.2,
                                            textAlign: 'center',
                                            ml: 2,
                                            display: 'flex',
                                            alignItems: 'center',
                                            whiteSpace: 'nowrap'
                                        }}
                                        >
                                            <HeaderTitle>Analytics overview for pot {chamberNumber}
                                                <Typography
                                                    component="span"
                                                    sx={{
                                                        color: '#333', // Noticeable color
                                                        fontSize: '0.95rem',
                                                        fontWeight: '500', // Semi-bold for a refined look
                                                        ml: 0.5,
                                                    }}
                                                >
                                                    (Last 30 days)
                                                </Typography>
                                            </HeaderTitle>
                                        </Typography>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>

                                            <a href="#" onClick={handleDownloadPDF} style={{ marginRight: '5px' }}>
                                                <img src={pdfIcon} alt="PDF" style={{ height: '50px' }} />
                                            </a>

                                            <a href="#" onClick={handleDownloadExcel} style={{ marginRight: '10px' }}>
                                                <img src={excelIcon} alt="Excel" style={{ height: '50px' }} />
                                            </a>
                                            <Link to="/Map">
                                                <CustomTooltip title="Back to map" aria-label="Go Back">
                                                    <IconButton sx={{ mr: 1 }}>
                                                        <img src={goBackIcon} alt="Go Back" style={{ height: '40px' }} />
                                                    </IconButton>
                                                </CustomTooltip>
                                            </Link>
                                            <RefreshIcon
                                                title="Refresh"
                                                src={refreshIcon}
                                                label="Click to refresh"
                                                alt="Refresh"
                                                onClick={() => window.location.reload()}
                                                sx={{ cursor: 'pointer' }}
                                            />
                                        </Box>
                                    </Box>

                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'flex-end',
                                            alignItems: 'center',
                                            marginTop: '10px',
                                        }}
                                    >

                                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', }}>

                                        </Box>
                                    </Box>
                                </CardContent>

                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <CardContent>
                                {loading ? (
                                    <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                                        <CircularProgress />
                                    </Box>
                                ) : (
                                    <>
                                        {/* Table One */}
                                        <Box sx={{ marginBottom: '20px' }}>
                                            <StyledTableContainer>
                                                <Table>
                                                    <StyledTableHead>
                                                        <TableRow>
                                                            <StyledTableColumn>Pot name</StyledTableColumn>
                                                            <StyledTableColumn>Total valve runs</StyledTableColumn>
                                                            <StyledTableColumn>Total valve alarms</StyledTableColumn>
                                                            <StyledTableColumn>Total float alarms</StyledTableColumn>
                                                            <StyledTableColumn>Total run time</StyledTableColumn>
                                                            <StyledTableColumn>Average run time</StyledTableColumn>
                                                            <StyledTableColumn>Max run time</StyledTableColumn>
                                                            <StyledTableColumn>Min run time</StyledTableColumn>
                                                        </TableRow>
                                                    </StyledTableHead>
                                                    <TableBody>
                                                        {detailedDataDefaultReport.length > 0 ? (
                                                            detailedDataDefaultReport.map((row, index) => (
                                                                <TableRow key={index}>
                                                                    <StyledTableCell>{row.HEADER || '0'}</StyledTableCell>
                                                                    <StyledTableCell>{row.Total_Cycles || '0'}</StyledTableCell>
                                                                    <StyledTableCell>{row.Total_ValveAlarm || '0'}</StyledTableCell>
                                                                    <StyledTableCell>{row.Total_floatAlarm || '0'}</StyledTableCell>
                                                                    <StyledTableCell>{row.Total_Duration || '0Sec'}</StyledTableCell>
                                                                    <StyledTableCell>{row.Avg_Duration || '0Sec'}</StyledTableCell>
                                                                    <StyledTableCell>{row.Max_Duration || '0Sec'}</StyledTableCell>
                                                                    <StyledTableCell>{row.Min_Duration || '0Sec'}</StyledTableCell>
                                                                </TableRow>
                                                            ))
                                                        ) : (
                                                            <TableRow>
                                                                <StyledTableCell colSpan={8}>Loading...</StyledTableCell>
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </StyledTableContainer>
                                        </Box>

                                        {/* Table Two */}
                                        <Box sx={{ marginBottom: '20px' }}>
                                            <StyledTableContainer>
                                                <Box display="flex" justifyContent="flex-end" mb={2}>
                                                    <Stack spacing={2}>
                                                        <Pagination
                                                            count={Math.ceil(detailedData2DefaultReport.length / rowsPerPageTwo)}
                                                            page={currentPageTwo}
                                                            onChange={handlePageChangeTwo}
                                                            variant="outlined"
                                                            color="primary"
                                                        />
                                                    </Stack>
                                                </Box>
                                                <Table>
                                                    <StyledTableHead>
                                                        <TableRow>
                                                            <StyledTableColumn>Pot name</StyledTableColumn>
                                                            <StyledTableColumn>Date</StyledTableColumn>
                                                            <StyledTableColumn>Total run time/day</StyledTableColumn>
                                                            <StyledTableColumn>Total runs/day</StyledTableColumn>
                                                        </TableRow>
                                                    </StyledTableHead>
                                                    <TableBody>
                                                        {paginatedDataTwo.length > 0 ? (
                                                            paginatedDataTwo.map((row, index) => (
                                                                <TableRow key={index}>
                                                                    <StyledTableCell>{row.POTS || 'NA'}</StyledTableCell>
                                                                    <StyledTableCell>{row.Date || 'NA'}</StyledTableCell>
                                                                    <StyledTableCell>{row.CYCLEDURATION || '0Sec'}</StyledTableCell>
                                                                    <StyledTableCell>{row.TotalCYCLES || '0'}</StyledTableCell>
                                                                </TableRow>
                                                            ))
                                                        ) : (
                                                            <TableRow>
                                                                <StyledTableCell colSpan={4}>Loading...</StyledTableCell>
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </StyledTableContainer>
                                        </Box>

                                        {/* Table Three */}
                                        <Box>
                                            <StyledTableContainer>
                                                <Box display="flex" justifyContent="flex-end" mb={2}>
                                                    <Stack spacing={2}>
                                                        <Pagination
                                                            count={Math.ceil(detailedData3.length / rowsPerPageOne)}
                                                            page={currentPageOne}
                                                            onChange={handlePageChangeOne}
                                                            variant="outlined"
                                                            color="primary"
                                                        />
                                                    </Stack>
                                                </Box>
                                                <Table>
                                                    <StyledTableHead>
                                                        <TableRow>
                                                            <StyledTableColumn>Pot</StyledTableColumn>
                                                            <StyledTableColumn>Start date</StyledTableColumn>
                                                            <StyledTableColumn>Start time</StyledTableColumn>
                                                            <StyledTableColumn>Stop date</StyledTableColumn>
                                                            <StyledTableColumn>Stop time</StyledTableColumn>
                                                            <StyledTableColumn>Run time</StyledTableColumn>
                                                        </TableRow>
                                                    </StyledTableHead>
                                                    <TableBody>
                                                        {paginatedDataOne.length > 0 ? (
                                                            paginatedDataOne.map((row, index) => (
                                                                <TableRow key={index}>
                                                                    <StyledTableCell>{row.POT || 'NA'}</StyledTableCell>
                                                                    <StyledTableCell>{formatDate(row.cycleStartTime) || 'NA'}</StyledTableCell>
                                                                    <StyledTableCell>{formatTime(row.cycleStartTime) || 'NA'}</StyledTableCell>
                                                                    <StyledTableCell>{formatDate(row.cycleStopTime) || 'NA'}</StyledTableCell>
                                                                    <StyledTableCell>{formatTime(row.cycleStopTime) || 'NA'}</StyledTableCell>
                                                                    <StyledTableCell>{row.DURATION || '0Sec'}</StyledTableCell>
                                                                </TableRow>
                                                            ))
                                                        ) : (
                                                            <TableRow>
                                                                <StyledTableCell colSpan={6}>Loading...</StyledTableCell>
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </StyledTableContainer>
                                        </Box>
                                    </>
                                )}
                            </CardContent>
                        </Grid>

                    </MainContent>
                </ContentContainer>
                <Footer />
                <ToastContainer />
            </div>
        </LocalizationProvider>
    );
};

export default MapOverview;